<template>

    <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3 class="mt-2">
            <h3 class="pa-1">{{ name }}</h3>
            <v-carousel v-if="shoudShowCarousel" height="300" hide-delimiters >
                <v-carousel-item
                        v-for="(url,i) in photos"
                        :key="i"
                        :src="url"
                        max-height="300"
                        contain
                ></v-carousel-item>
            </v-carousel>
            <v-img contain v-if="photos && photos.length==1" :src="photos[0]" max-height="300"/>

            <p class="pa-1">{{ description }}</p>
            <p class=" ml-2"><span class="title">{{priceFormatted}}</span><span class="">{{numPurchaseText}}</span>
            <span class="caption">(税・手数料込)
                <span v-if="!feeIncluded">店頭現金価格:{{originalPriceFormatted}}</span>
                <!--
                <span v-if="feeIncluded">店頭現金価格({{priceFormatted}})と同価格</span>
                -->
            </span>

            </p>
        </v-flex>

        <v-flex xs12 sm6 offset-sm3 >
            <v-select
                    v-if="maxNumberOfItem"
                    class="ma-2"
                    :items="numOfPurchase"
                    label="数量"

                    v-model="userSelected['numOfPurchase']"
                    outline
                    hide-details
                    @change="selectChanged"
            ></v-select>
        </v-flex>

        <v-flex xs12 sm6 offset-sm3>
            <v-alert :value="true"
                     outline
                     color="warning"
                     v-if="maxNumberOfItemPerOrder && !showBackExclusiveAlreadyExists"
            >この商品は1回のご注文で最大で{{maxNumberOfItemPerOrder}}個のみご注文可能です。あと{{maxNumberOfItem}}個を選択可能です</v-alert>
        </v-flex>



        <template v-for="(option,index) in options">
            <v-flex xs12 sm6 offset-sm3 :key="index">
                <v-select
                        class="ma-2"
                        :items="option.candidates"
                        :label="option.name"
                        item-text="name"
                        item-value="candId"
                        v-model="userSelected[option.optionId]"
                        outline
                        hide-details
                        @change="selectChanged"
                >

                </v-select>
            </v-flex>
        </template>
        <v-flex xs12 sm6 offset-sm3 v-if="maxNumberOfItem">
            <v-layout class="shoppingButtons">
                <v-flex xs6 class="pa-2">
                    <v-btn block color="white" v-on:click="addItem" class="addCartButton">
                        カートに追加  >

                    </v-btn>
                </v-flex>
                <v-flex xs6 class="pa-2">
                    <v-btn block color="#b70e0e" v-on:click="addItem('setDateTimeMethod')" class="checkOutButton">
                        購入手続き  >

                    </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex xs12 sm6 offset-sm3 v-if="showBackExclusiveAlreadyExists">
            <v-alert :value="true"
                     color="error"
            >このクーポンは、他のクーポンと併用できません。このクーポンを選択したい場合は、まずカートから既存のクーポンを削除してください。</v-alert>

            <v-layout class="shoppingButtons">
                <v-flex xs6 offset-xs3 class="pa-2">
                    商品を追加できません。
                    <v-btn block color="white" @click="goItemList" class="addCartButton">
                        ← 商品一覧に戻る
                    </v-btn>
                </v-flex>
            </v-layout>

        </v-flex>

        <v-dialog v-model="noItemCanSelectDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">すでに最大数を選択済です</v-card-title>
                <v-card-text>1回の注文で注文いただける数の最大数({{maxNumberOfItemPerOrder}}個)に達しています。これ以上は選択できません。</v-card-text>
                <v-card-actions>
                    <v-btn color="green darken-1" flat @click="goItemList">商品一覧に戻る</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>





    </v-layout>




</template>

<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('Detail','INFO');
    import { AmplifyEventBus } from 'aws-amplify-vue'
    import { uuid } from 'vue-uuid';

    import {PriceMixIns} from '../mixins/price'

    export default {
        mixins:[PriceMixIns],
        data() {
            return {
                itemId:undefined,
                detail: undefined,
                photos: undefined,
                lang:undefined,
                currency:undefined,
                maxNumberOfItem:undefined,
                numOfPurchase:[],
                options:[],
                userSelected:{},
                nameWithOption:name,
                price:0,
                priceDiff:0,
                originalPrice:0,
                numPurchaseText:"",
                maxNumberOfItemPerOrder:0,
                noItemCanSelectDialog:false,
                showBackExclusiveAlreadyExists:false,
            }
        },
        created() {
            logger.info("Detail created")
            AmplifyEventBus.$on('detail', this.setDetail )
            AmplifyEventBus.$on('priceWithTax', this.priceWithTax )
        },
        beforeDestroy () {
            logger.info("Detail beforeDestroy")
            AmplifyEventBus.$off('detail', this.setDetail )
            AmplifyEventBus.$off('priceWithTax', this.priceWithTax )
        },
        async mounted() {
            logger.info("query",this.$route)
            this.itemId = this.$route.query.itemId
            const backTo = {}
            backTo.path = "/"
            backTo.hash = this.itemId
            AmplifyEventBus.$emit('setBackTo', backTo)
            this.trackPage('/detail/?itemId='+this.itemId)
            if(this.$store.state.appReady){
                logger.info("app is already ready.")
                AmplifyEventBus.$emit('requestDetail', this.itemId)
            }else{
                logger.info("app is not ready. waiting...")
            }


        },
        methods: {

            selectChanged:function(){
              logger.info("showUserSelected",this.userSelected)
                this.setNumPurchaseText()
                this.setNameWithOption()
                this.getPriceDiffThenEmit()
            },
            setNumPurchaseText:function(){
                if(this.userSelected.numOfPurchase > 1){
                    this.numPurchaseText = " x " + this.userSelected.numOfPurchase + " "
                }else{
                    this.numPurchaseText = ""
                }
            },
            setDetail: function (data) {

                logger.info("data per item",data)
                document.title = this.$store.state.shopName + " | " + data.item.name["ja-JP"]
                AmplifyEventBus.$emit('setJourney', {key:"page",value:data.item} )
                this.detail = data
                if(data.item.photos){
                    this.photos = data.item.photos
                }
                this.lang = data.defalutSettings.defaultLang
                this.currency = data.defalutSettings.currency

                // gen numPurchase
                if(!data.item.maxNumberOfItem){
                    this.maxNumberOfItem = 10
                }else{
                    this.maxNumberOfItem = data.item.maxNumberOfItem
                }
                for(let i=1;i<=this.maxNumberOfItem;i++){
                    this.numOfPurchase.push(i) // for select options
                }

                //maxNumberOfItemPerOrder
                if(data.item.maxNumberOfItemPerOrder
                    && parseInt(data.item.maxNumberOfItemPerOrder) > 0){
                    this.maxNumberOfItemPerOrder = parseInt(data.item.maxNumberOfItemPerOrder)
                    logger.info("maxNumberOfItemPerOrder",this.maxNumberOfItemPerOrder)
                    this.updateNumOfPurchaseSelectItems()
                }

                //exclusiveCouponGroupId
                if(data.item.exclusiveCouponGroupId){
                    this.checkExclusiveCouponItem()
                }


                // prepare userSelected
                this.userSelected['numOfPurchase']=1
                // gen options and default value for userSelected
                // it also calc priceDiff

                const options = []
                for(let j in data.item.options){
                    // Is the option string or object?
                    const optionItem = data.item.options[j]
                    logger.info("optionItem",optionItem)
                    if(typeof optionItem == "string" && data.optionDetail[optionItem]){

                        logger.info("gen option found string")
                        let obj = {}
                        obj.optionId = j + "__" + optionItem
                        logger.info("data.optionDetail[obj.optionId]",data.optionDetail)
                        obj.name = data.optionDetail[optionItem].name[this.lang]
                        obj.candidates = []
                        for(let m in data.optionDetail[optionItem].candidates){
                            const candidateGroupId = data.optionDetail[optionItem].candidates[m]
                            for(let k in data.candidatesGroup[candidateGroupId]){
                                const candidateId = data.candidatesGroup[candidateGroupId][k]
                                //logger.info("k",candidateId)
                                //logger.info(data.candidatesDetail[candidateId])
                                const cand={}
                                if(!data.candidatesDetail[candidateId]){
                                    continue
                                }
                                cand.value = data.candidatesDetail[candidateId].value
                                cand.priceAffect = data.candidatesDetail[candidateId].priceAffect
                                cand.candId = candidateId
                                cand.priceAffectToDisplayWithTax = this.priceAffectToDisplayWithTax(cand.priceAffect)
                                let name = data.candidatesDetail[candidateId].name[this.lang]
                                //logger.info("price affect "+name,cand.priceAffect)
                                if(cand.priceAffect != 0 && cand.priceAffect!= undefined){
                                    if(cand.priceAffect >0){
                                        name += " (+"
                                    }else{
                                        name += " (-"
                                    }

                                    name += this.getCurrencyFormatted(cand.priceAffectToDisplayWithTax)
                                    name += ")"
                                }

                                cand.name = name
                                obj.candidates.push(cand)
                            }
                        }
                        options.push(obj)
                        this.userSelected[obj.optionId]=obj.candidates[0].candId




                    }else if(typeof optionItem != "string" ){
                        logger.info("option is obj.",optionItem)
                        logger.info("gen option found object")

                        let obj = {}
                        obj.name = optionItem.name[this.lang]
                        obj.optionId = j + "__" + optionItem.optionId
                        obj.candidates = []
                        for(let k in optionItem.candidates){
                            const cand={}
                            cand.value=optionItem.candidates[k].value
                            cand.priceAffect=optionItem.candidates[k].priceAffect
                            cand.candId=optionItem.candidates[k].candId
                            let name=optionItem.candidates[k].name[this.lang]

                            if(cand.priceAffect != 0 && cand.priceAffect != undefined){
                                if(cand.priceAffect >0){
                                    name += " (+"
                                }else{
                                    name += " (-"
                                }

                                name += this.getCurrencyFormatted(cand.priceAffect)
                                name += ")"
                            }

                            cand.name = name
                            obj.candidates.push(cand)
                        }
                        options.push(obj)
                        this.userSelected[obj.optionId]=obj.candidates[0].candId
                    }

                }
                logger.info("options",options)
                this.options = options
                this.getPriceDiffThenEmit()


            },
            priceAffectToDisplayWithTax:function(actualDiff){
                let res = actualDiff
                if(this.detail
                    && this.detail.item
                        && this.detail.item.adtFeesRatio
                    && !this.detail.item.includeAdtFees){
                    const adtFee = this.detail.item.adtFeesRatio["adt"]
                    res = res * (1 + adtFee)
                }
                if(this.detail
                    && this.detail.item
                    && this.detail.item.tax
                    && this.detail.item.tax == "excluded"){
                    res = res * (1 + 0.08)
                }
                return res

            },
            isOption:function(key){
                let res = false
                for(let j in this.detail.item.options) {
                    const optionItem = this.detail.item.options[j]
                    if (typeof optionItem == "string") {
                        if(key == optionItem){
                            res = true
                        }else if(key.indexOf("__")>=0){
                            const trimPos = key.indexOf("__") + 2
                            const trimmedKey = key.substr(trimPos)
                            //logger.info("trimmedKey",trimmedKey)
                            if(trimmedKey == optionItem) {
                                if(typeof optionItem == "string"){
                                    res = this.detail.optionDetail[optionItem].name[this.lang]
                                }else{
                                    res = optionItem.name[this.lang]
                                }
                            }
                        }
                    }
                }
                logger.info("isOption "+key,res)
                return res
            },
            optionTextFromUserSelect:function(){
                let res = ""
                for(let key in this.userSelected){
                    if(this.isOption(key)){
                        const optionText = this.isOption(key)
                        res += "(" + optionText + ")"
                        const candId = this.userSelected[key]
                        res += this.detail.candidatesDetail[candId].name[this.lang]
                        res += " "
                    }
                }
                return res
            },

            setNameWithOption:function(){
                let nameWithOption = ""
                nameWithOption += this.userSelected.numOfPurchase
                nameWithOption += " x "
                nameWithOption += this.name
                logger.info("setNameWithOption userSelected",this.userSelected)
                nameWithOption += this.optionTextFromUserSelect()


                for(let j in this.detail.item.options) {
                    const optionItem = this.detail.item.options[j]
                    nameWithOption += " "
                    logger.info("optionItem",optionItem)
                    if(typeof optionItem == "string"){

                        if(this.detail.optionDetail[optionItem]){
                            /*
                            nameWithOption += "("
                            nameWithOption += this.detail.optionDetail[optionItem].name[this.lang]
                            nameWithOption += "):"

                            nameWithOption += this.userSelectedText(optionItem)

                            const candId = this.userSelected[optionItem]
                            logger.info("candId",candId)
                            //logger.info("this.userSelected",this.userSelected)
                            nameWithOption += this.detail.candidatesDetail[candId].name[this.lang]

                             */
                        }
                    }else{
                        nameWithOption += "("
                        nameWithOption += optionItem.name[this.lang]
                        const candId = this.userSelected[optionItem.optionId]
                        nameWithOption += "):"
                        for(let k in optionItem.candidates){
                            if(optionItem.candidates[k].candId == candId){
                                nameWithOption += optionItem.candidates[k].name[this.lang]
                            }
                        }
                    }
                }
                this.nameWithOption = nameWithOption
            },
            priceWithTax:function(data){
                //logger.info("priceWithTax",data)
                if(data.priceDiff == this.priceDiff &&
                data.itemId == this.itemId){
                    this.price = data.priceNaked
                }
                this.originalPrice = data.originalPrice
            },

            getPriceDiffFromUserSelect:function(){
                let priceDiff=0
                for(let key in this.userSelected){
                    if(this.isOption(key)){
                        const candId = this.userSelected[key]
                        if(this.detail.candidatesDetail[candId]){
                            priceDiff += parseFloat(this.detail.candidatesDetail[candId].priceAffect)
                            logger.info("preiceDiff str",this.detail.candidatesDetail[candId].priceAffect)
                        }
                    }
                }
                return priceDiff
            },

            getPriceDiffThenEmit:function(){
                //const priceDiff =
                /*
                for(let j in this.detail.item.options) {

                    const optionItem = this.detail.item.options[j]

                    if(typeof optionItem == "string"){
                        //logger.info("string optionItem ignored")

                        const candId = this.userSelected[optionItem]
                        if(this.detail.candidatesDetail[candId]){
                            priceDiff += parseFloat(this.detail.candidatesDetail[candId].priceAffect)
                            logger.info("preiceDiff str",this.detail.candidatesDetail[candId].priceAffect)
                        }
                    }else{
                        const candId = this.userSelected[optionItem.optionId]
                        for(let k in optionItem.candidates){
                            if(optionItem.candidates[k].candId == candId){
                                logger.info("preiceDiff",optionItem.candidates[k].priceAffect)
                                priceDiff += parseFloat(optionItem.candidates[k].priceAffect)
                            }
                        }
                    }

                }
                 */
                this.priceDiff = this.getPriceDiffFromUserSelect()
                const dataToEmit = {}
                dataToEmit.itemId = this.itemId
                dataToEmit.priceDiff = this.priceDiff
                AmplifyEventBus.$emit('getPriceWithTax', dataToEmit)

            },

            addItem:async function(destination="none") {
                this.setNameWithOption()
                const dataToEmit = {}
                dataToEmit.cartItemId = "cart_item_" + uuid.v4()
                dataToEmit.itemId = this.itemId
                dataToEmit.userSelected = this.userSelected
                dataToEmit.nameWithOption = this.nameWithOption
                dataToEmit.price = this.price
                dataToEmit.priceDiff = this.priceDiff
                dataToEmit.numOfPurchase = dataToEmit.userSelected.numOfPurchase
                dataToEmit.subtotal = dataToEmit.price * dataToEmit.userSelected.numOfPurchase
                dataToEmit.exclusiveCouponGroupId = this.detail.item.exclusiveCouponGroupId
                if(this.photos && this.photos[0]){
                    dataToEmit.image = this.photos[0]
                }
                AmplifyEventBus.$emit('addCart', dataToEmit)
                AmplifyEventBus.$emit('setJourney', {key:"addCart",value:dataToEmit} )
                this.$gtag.event('conversion', {'send_to': 'AW-736955098/M1yLCKmcldkBENqVtN8C'})
                this.fbTrack('AddToCart',{content_ids:[this.itemId]})

if(destination == "setDateTimeMethod"){
                    await this.$router.push('/setDateTimeMethod').catch((e)=>{
                        logger.info("router err",e)
                    })
                }else{
                    this.$router.push('/cart')
                }
            },
            updateNumOfPurchaseSelectItems:function(){
                const cartState = this.$store.state.cartCurrent
                const currentPremiseId = this.$store.state.placeIdParam
                logger.info("currentPremiseId",currentPremiseId)
                logger.info("cart",cartState[currentPremiseId])
                if(!cartState[currentPremiseId]
                    || !cartState[currentPremiseId].cart
                    || !cartState[currentPremiseId].cart.items){
                    return
                }
                const cart = cartState[currentPremiseId].cart
                logger.info("cart",cart)
                let numSelected = 0
                for(let i in cart.items){
                    const cartItem = cart.items[i]
                    if(cartItem.itemId == this.itemId){
                        numSelected += cartItem.numOfPurchase
                    }
                }
                logger.info("updateNumOfPurchaseSelectItems")
                logger.info("numSelected",numSelected)


                if(this.maxNumberOfItemPerOrder >= numSelected){
                    this.maxNumberOfItem = this.maxNumberOfItemPerOrder - numSelected
                    if(this.maxNumberOfItem > 0){
                        logger.info("updating num purchase")
                        this.numOfPurchase = []
                        for(let i=1;i<=this.maxNumberOfItem;i++){
                            this.numOfPurchase.push(i) // for select options
                        }
                    }else{
                        this.noItemCanSelectDialog = true
                    }
                }
            },
            checkExclusiveCouponItem:function(){
                const couponGroupId = this.detail.item.exclusiveCouponGroupId
                logger.info("checkExclusiveCouponItem couponGroupId",couponGroupId)
                if(!couponGroupId){
                    return
                }

                const cartState = this.$store.state.cartCurrent
                const currentPremiseId = this.$store.state.placeIdParam

                if(!cartState[currentPremiseId]
                    || !cartState[currentPremiseId].cart
                    || !cartState[currentPremiseId].cart.items){
                    return
                }
                const cart = cartState[currentPremiseId].cart
                logger.info("cart items",cart.items)

                for(let i in cart.items){
                    const cartItem = cart.items[i]
                    if(cartItem.itemId == this.itemId){
                        logger.info("checkExclusiveCouponItem: same itemId found. ok")
                    }else{
                        if(cartItem.exclusiveCouponGroupId == couponGroupId){
                            logger.info("other exclusive item already exist")
                            logger.info("set max number 0")
                            this.maxNumberOfItem = 0
                            this.showBackExclusiveAlreadyExists = true
                        }
                    }


                }
            },
            goItemList:function(){
                const backTo = {}
                backTo.path = "/"
                backTo.hash = this.itemId
                this.$router.push(backTo)
            }

        },
        computed:{
            feeIncluded:function(){
                if(this.detail
                        && this.detail.item
                    && this.detail.item.includeAdtFees){
                    return true
                }else{
                    return false
                }
            },
            name:function(){
                let res
                if(this.detail){
                    res = this.detail.item.name[this.lang]
                }
                return res
            },
            description: function(){
                let res
                if(this.detail && this.detail.item && this.detail.item.description && this.detail.item.description[this.lang]){

                    res = this.detail.item.description[this.lang]
                }
                return res
            },
            priceFormatted:function(){
                let res
                if(this.detail){
                    res = this.getCurrencyFormatted(this.price)
                }

                return res
            },
            shoudShowCarousel:function(){
                if(this.photos && this.photos.length>1){
                    return true
                }else{
                    return false
                }
            },
            originalPriceFormatted:function(){
                let res
                if(this.detail){
                    let orignWithDiff = this.originalPrice + this.priceDiff
                    if(this.detail.item && this.detail.item.tax == "excluded"){
                        orignWithDiff = this.originalPrice + this.priceDiff * 1.08
                    }
                    res = this.getCurrencyFormatted(orignWithDiff)
                }

                return res
            },
            appReady:function(){
                return this.$store.state.appReady
            },



        },
        watch:{
            appReady:function(val){
                if(val){
                    logger.info("appReady")
                    AmplifyEventBus.$emit('requestDetail', this.itemId)
                }
            }

        }

    }


    </script>
<style>

    .v-text-field--outline > .v-input__control > .v-input__slot {
        background: white !important;
        border-radius: 8px;
    }

    .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
        border: 2px solid white;
    }

    .shoppingButtons .v-btn{
        height:60px;
        border-radius: 10px;
        border:#b70e0e 3px solid !important;
    }

    .shoppingButtons .addCartButton .v-btn__content{
        color:Black;
        font-weight: bold;
    }

    .shoppingButtons .checkOutButton .v-btn__content{
        color:white;
        font-weight: bold;
    }


</style>